import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ReviewStatusIndicator from './ReviewStatusIndicator'

import {
  isInternalReviewer,
  isOeReviewer,
  isQuestCopyEditorOrQuestAuthorOrQuestManager
} from '../../../utils/user'
import {
  findRejectedReview,
  questIsInQualityReview
} from '../../../utils/review'
import { messages } from '../../../utils/messages/label'

export default class ReviewStatusIndicators extends Component {
  render() {
    const { currentReviews, reviewStatus, approvals, user, quest } = this.props
    const { intl } = this.context

    const intlReviewTypes = {
      standards: intl.formatMessage(messages.standards),
      final: intl.formatMessage(messages.final),
      experience: intl.formatMessage(messages.experience),
      subject: intl.formatMessage(messages.subject),
      copy: intl.formatMessage(messages.copy)
    }

    return (
      <div id="reviewStatusIndicatorContainer">
        {this.showInternalReviewStatusIndicators() && (
          <div className="internal-review-status-indicators">
            {['experience', 'subject', 'copy'].map((type, index) => {
              return (
                <ReviewStatusIndicator
                  reviewType={type}
                  reviewStatus={reviewStatus}
                  currentReviews={approvals}
                  intlReviewType={intlReviewTypes[type]}
                  user={user}
                  key={index}
                  quest={quest}
                />
              )
            })}
          </div>
        )}
        {this.showOeReviewStatusIndicators() && (
          <div className="oe-review-status-indicators">
            {['standards', 'final'].map((type, index) => {
              return (
                <ReviewStatusIndicator
                  reviewType={type}
                  reviewStatus={reviewStatus}
                  currentReviews={currentReviews}
                  intlReviewType={intlReviewTypes[type]}
                  user={user}
                  key={index}
                  quest={quest}
                />
              )
            })}
          </div>
        )}
      </div>
    )
  }

  showInternalReviewStatusIndicators() {
    const { user, quest, organization, approvals, reviewStatus } = this.props
    return (
      (isInternalReviewer(user) ||
        isQuestCopyEditorOrQuestAuthorOrQuestManager(
          user,
          quest,
          organization
        )) &&
      reviewStatus === 'draft' &&
      approvals.length > 0
    )
  }

  showOeReviewStatusIndicators() {
    const { user, quest, reviewStatus, currentReviews, organization } =
      this.props
    const rejectedReview = findRejectedReview(currentReviews)
    var retVal = false
    if (isOeReviewer(user, quest) && questIsInQualityReview(quest)) {
      retVal = true
    } else if (
      isQuestCopyEditorOrQuestAuthorOrQuestManager(user, quest, organization) &&
      reviewStatus === 'rejected' &&
      ['standards', 'final'].includes(rejectedReview)
    ) {
      retVal = true
    }
    return retVal
  }
}

ReviewStatusIndicators.propTypes = {
  reviewStatus: PropTypes.string,
  user: PropTypes.object.isRequired,
  currentReviews: PropTypes.array,
  quest: PropTypes.object.isRequired,
  organization: PropTypes.object.isRequired,
  approvals: PropTypes.array
}

ReviewStatusIndicators.contextTypes = {
  intl: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/questbanner/ReviewStatusIndicators.js